import React from 'react';
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import Icon from "@amzn/awsui-components-react-v3/polaris/icon";
import {DownloadS3File} from '../util/DownloadS3FileComponent';
import {AppConfig, AppConfigMapKey} from "../pages/config/AppConfig";
import {DOWNLOAD_FILE_STATUS_MESSAGES, HELP_PANE} from "../util/ConfigConstants";
import {Error} from "../util/ReactUtil";
import { HelpPanel, Link } from '@amzn/awsui-components-react-v3';

interface ShipmentHelpState {
    DownloadAsnWithoutBookingUserGuideErrorMessage: string | null,
    DownloadBookingUserGuideErrorMessage: string | null,
    DownloadDmsUserGuideErrorMessage: string | null,
    DownloadMandarinUserGuideErrorMessage: string | null,
    DownloadEnglishWebinarVideoErrorMessage: string | null,
    DownloadMandarinWebinarVideoErrorMessage: string | null
}
  
export default class ShipmentHelp extends React.Component<any, ShipmentHelpState> {

    constructor(props: any) {
        super(props);
        this.state = {
            DownloadAsnWithoutBookingUserGuideErrorMessage: null,
            DownloadBookingUserGuideErrorMessage: null,
            DownloadDmsUserGuideErrorMessage: null,
            DownloadMandarinUserGuideErrorMessage: null,
            DownloadEnglishWebinarVideoErrorMessage: null,
            DownloadMandarinWebinarVideoErrorMessage: null
        }
    }

    onDownloadAsnWithoutBookingUserGuideError = (error: string) => {
        this.setState({DownloadAsnWithoutBookingUserGuideErrorMessage: error});
    }

    onDownloadAsnWithoutBookingUserGuideSuccess = () => {
        this.setState({DownloadAsnWithoutBookingUserGuideErrorMessage: null});
    }

    onDownloadBookingUserGuideError = (error: string) => {
        this.setState({DownloadBookingUserGuideErrorMessage: error});
    }

    onDownloadDmsUserGuideError = (error: string) => {
        this.setState({DownloadDmsUserGuideErrorMessage: error});
    }

    onDownloadBookingUserGuideSuccess = () => {
        this.setState({DownloadBookingUserGuideErrorMessage: null});
    }

    onDownloadDmsUserGuideSuccess = () => {
        this.setState({DownloadDmsUserGuideErrorMessage: null});
    }

    onDownloadMandarinUserGuideError = (error: string) => {
        this.setState({DownloadMandarinUserGuideErrorMessage: error});
    }

    onDownloadMandarinUserGuideSuccess = () => {
        this.setState({DownloadMandarinUserGuideErrorMessage: null});
    }

    onDownloadEnglishWebinarVideoError = (error: string) => {
        this.setState({DownloadEnglishWebinarVideoErrorMessage: error});
    }

    onDownloadEnglishWebinarVideoSuccess = () => {
        this.setState({DownloadEnglishWebinarVideoErrorMessage: null});
    }

    onDownloadMandarinWebinarVideoError = (error: string) => {
        this.setState({DownloadMandarinWebinarVideoErrorMessage: error});
    }

    onDownloadMandarinWebinarVideoSuccess = () => {
        this.setState({DownloadMandarinWebinarVideoErrorMessage: null});
    }
    
    render() {
        return (
            <HelpPanel header={
                <Box variant='h2'>Shipments Portal</Box>
                }
                footer={
                    <Box>
                    <Box variant='h3'>Need help?</Box>
                    <Box>
                        <ul>Self Serve:
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"ASN without booking guide"}
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.ASN_WITHOUT_BOOKING_USER_GUIDE_URI)}
                                    onSuccess={this.onDownloadAsnWithoutBookingUserGuideSuccess}
                                    onError={this.onDownloadAsnWithoutBookingUserGuideError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_USER_GUIDE_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadAsnWithoutBookingUserGuideErrorMessage, true, !!this.state.DownloadAsnWithoutBookingUserGuideErrorMessage)}</Box>
                            </li>
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"Booking user guide"}
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.BOOKING_USER_GUIDE_URI)}
                                    onSuccess={this.onDownloadBookingUserGuideSuccess}
                                    onError={this.onDownloadBookingUserGuideError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_USER_GUIDE_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadBookingUserGuideErrorMessage, true, !!this.state.DownloadBookingUserGuideErrorMessage)}</Box>
                            </li>
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"DMS user guide"}
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.DMS_USER_GUIDE_URI)}
                                    onSuccess={this.onDownloadDmsUserGuideSuccess}
                                    onError={this.onDownloadDmsUserGuideError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_USER_GUIDE_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadDmsUserGuideErrorMessage, true, !!this.state.DownloadDmsUserGuideErrorMessage)}</Box>
                            </li>
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"预订用户指南-普通话"} // Booking user guide-mandarin
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.USER_GUIDE_URI_MANDARIN)}
                                    onSuccess={this.onDownloadMandarinUserGuideSuccess}
                                    onError={this.onDownloadMandarinUserGuideError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_USER_GUIDE_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadMandarinUserGuideErrorMessage, true, !!this.state.DownloadMandarinUserGuideErrorMessage)}</Box>
                            </li>
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"Booking portal webinar-english"}
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.WEBINAR_VIDEO_LINK_ENGLISH)}
                                    onSuccess={this.onDownloadEnglishWebinarVideoSuccess}
                                    onError={this.onDownloadEnglishWebinarVideoError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_WEBINAR_VIDEO_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadEnglishWebinarVideoErrorMessage, true, !!this.state.DownloadEnglishWebinarVideoErrorMessage)}</Box>
                            </li>
                            <li>
                                <DownloadS3File
                                    variant={"link"}
                                    text={"预订门户网络研讨会-普通话"}  // Booking portal webinar-mandarin
                                    icon={"download"}
                                    enableLoading={true}
                                    s3Uri={AppConfig.getConfigValue(AppConfigMapKey.WEBINAR_VIDEO_LINK_MANDARIN)}
                                    onSuccess={this.onDownloadMandarinWebinarVideoSuccess}
                                    onError={this.onDownloadMandarinWebinarVideoError}
                                    onErrorMessage={DOWNLOAD_FILE_STATUS_MESSAGES.DOWNLOAD_WEBINAR_VIDEO_ERROR_MESSAGE}
                                />
                                <Box>{Error("", this.state.DownloadMandarinWebinarVideoErrorMessage, true, !!this.state.DownloadMandarinWebinarVideoErrorMessage)}</Box>
                            </li>
                        </ul>
                        <ul>
                            <Box variant='h4'>External User </Box>
                            <Box margin={{ left: "s" }}>
                                <li>Email: <Link href="mailto:aws-scm-shipment-support@amazon.com">aws-scm-shipment-support@amazon.com</Link></li>
                            </Box>
                        </ul>
                        <ul>
                            <Box variant='h4'>AWS User </Box>
                            <Box margin={{ left: "s" }}>
                                <li>
                                    <Link href="https://t.corp.amazon.com/create/templates/08b63b70-8807-4e2e-a6cc-afe65df53979"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                    Report an issue <Icon variant="link" name="external" url=""></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://issues.amazon.com/issues/create?assignedFolder=65e6fa80-004c-4f7d-94d1-5227f430c5dc&title=Feature+Request+%3A+%28*Team*%29+%3A+%28*Title+of+Feature+Request*%29&description=Summary+of+the+ask%3A%0A%0ACurrent+Process%2FStatus%3A%0A%0AImpact+of+this+feature+request+on+current+process%2Fstatus%3A%0A%0AReturn+on+Investment+%28What+is+the+productivity%2Fquality%2Fsafety%2Foverall+impact+of+this+feature+request%29%3F%3A&descriptionContentType=text%2Fplain&extensions%5Btt%5D%5Bimpact%5D=3&extensions%5Btt%5D%5BminImpact%5D=3&extensions%5Btt%5D%5Bcategory%5D="
                                        target="_blank"
                                        rel="noopener noreferrer">
                                    Feature Request <Icon variant="link" name="external" url=""></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://issues.amazon.com/issues/create?assignedFolder=5919327d-2604-4389-be52-a492b4ce7dff&title=Questions%2FInquiries+%3A+%28*Team*%29+%3A+%28*Title+of+Feature+Request*%29&description=Question%2FInquiry%3A%0A&descriptionContentType=text%2Famz-markdown-sim&extensions%5Btt%5D%5Bcategory%5D="
                                        target="_blank"
                                        rel="noopener noreferrer">
                                    Questions/Inquiries <Icon variant="link" name="external" url=""></Icon>
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://w.amazon.com/bin/view/AWS_Transportation/Feedback/"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                    Contact AWS-T <Icon variant="link" name="external" url=""></Icon>
                                    </Link>
                                </li>
                            </Box>
                            <hr />
                            <Box variant="span" color="text-status-inactive">
                                <i>* Reach out to your GSMs in case of questions regarding using this portal or its user guide</i>
                            </Box>
                        </ul>
                    </Box>
                </Box>
                }>
                <Box variant='p'>{HELP_PANE.DESCRIPTION}</Box>
            </HelpPanel>
        );
    }
}
